import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";
import {Localiser} from "../../../services/localiser";
import {PlanoService} from "../../../services/plano.service";
import {ImagesService} from "../../../services/images.service";
import {ProyectoService} from "../../../services/proyecto.service";
import {plano} from "../../../models/plano";

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.css']
})
export class UploadComponent implements OnInit {


  public formData = new FormData();
  public selectedFile: File = null;
  public nameFile: string = "";
  public nameOriginalFile: string = "";
  public descriptionFile: string = this.localiser.get('select_floorplans.description');
  public nameFileEmpty: boolean = false;
  public metrosPlano: number = 25;
  public escalaLuminarias: number = 1;

  fileError: string = null;

  constructor(public dialogRef: MatDialogRef<UploadComponent>, public localiser: Localiser,
              public planoService: PlanoService, public imagesService: ImagesService,
              public proyectoService: ProyectoService) { }

  ngOnInit(): void {
  }

  onSelectFile(event: any) {
    const file: File = event.target.files[event.target.files.length - 1];

    if (!file) return;

    // Validate file type (MIME and/or extension)
    const isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');

    if (!isSvg) {
      // Handle error – e.g., show a message or set a flag
      this.fileError = 'Only SVG files are allowed.';
      this.selectedFile = null;
      this.nameOriginalFile = '';
      this.nameFile = '';
      return;
    }

    // Reset any previous error
    this.fileError = null;

    // Set file values
    this.selectedFile = file;
    this.nameOriginalFile = file.name;
    this.nameFile = file.name.split('.').slice(0, -1).join('.');
  }


  changeFileName() {
    this.nameFileEmpty = this.nameFile == "" || this.nameFile == null;
  }

  performUpload() {
    if (this.nameFile == "" || this.nameFile == null) {
      this.nameFileEmpty = true;
    } else {
      this.formData.set('file', this.selectedFile, this.selectedFile.name);
      this.imagesService.uploadImage(this.formData).subscribe(
        res => {
          let plano: plano = {
            idPlano: "ID",
            idProyecto: this.proyectoService.getProyectoActual().idProyecto,
            nombre: this.nameFile,
            descripcion: this.descriptionFile,
            imagenPlano: res,
            idPlanoSiguiente: "",
            idPlanoAnterior: "",
            metrosPlano: this.metrosPlano,
            escalaLuminarias: this.escalaLuminarias
          }
          this.planoService.new(plano).subscribe(result => {
            this.onCancelClick();
          });
        }
      );
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

}
